import React, { useContext, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";

import {
	TeamOutlined,
	LogoutOutlined,
	DollarCircleOutlined,
	ShoppingCartOutlined,
	UsergroupAddOutlined,
	FileTextOutlined,
	MoneyCollectOutlined,
	ClockCircleOutlined,
	MessageOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../../../context/AuthContext";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
	const location = useLocation();
	const { pathname } = location;
	const { logout } = useContext(AuthContext);

	const trigger = useRef(null);
	const sidebar = useRef(null);

	// const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
	// const [sidebarExpanded, setSidebarExpanded] = useState(
	//   storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
	// );

	// const menuItems = [
	//   {
	//     key: "courses",
	//     icon: <DollarCircleOutlined />,
	//     label: "Courses",
	//     path: "/admin/courses",
	//   },
	//   {
	//     key: "courses-category",
	//     icon: <ShoppingCartOutlined />,
	//     label: "course category ",
	//     path: "/admin/courseCategory",
	//   },
	//   {
	//     key: "teachers",
	//     icon: <CalendarOutlined />,
	//     label: "Teacher",
	//     path: "/admin/teachers",
	//   },
	//   {
	//     key: "resources",
	//     icon: <GlobalOutlined />,
	//     label: "Resources",
	//     path: "/admin/resources",
	//   },
	//   {
	//     key: "students",
	//     icon: <TeamOutlined />,
	//     label: "Students",
	//     path: "/admin/students",
	//   },
	//   {
	//     key: "payments",
	//     icon: <TeamOutlined />,
	//     label: "Payment History",
	//     path: "/admin/payments",
	//   },
	//   {
	//     key: "chats",
	//     icon: <MessageOutlined />,
	//     label: "Chats",
	//     path: "/admin/chats",
	//   },
	// ];

	const menuItems = [
		{
			key: "courses",
			icon: <DollarCircleOutlined />,
			label: "Courses",
			path: "/admin/courses",
		},
		{
			key: "courses-category",
			icon: <ShoppingCartOutlined />,
			label: "Course Category",
			path: "/admin/courseCategory",
		},
		{
			key: "classrooms",
			icon: <ClockCircleOutlined />,
			label: "Classrooms",
			path: "/admin/Classrooms",
		},
		{
			key: "teachers",
			icon: <UsergroupAddOutlined />, // Changed to a user group icon for teachers
			label: "Teachers",
			path: "/admin/teachers",
		},
		{
			key: "students",
			icon: <TeamOutlined />,
			label: "Students",
			path: "/admin/students",
		},
		{
			key: "resources",
			icon: <FileTextOutlined />, // Changed to a file text icon for resources
			label: "Resources",
			path: "/admin/resources",
		},
		{
			key: "payments",
			icon: <MoneyCollectOutlined />, // Changed to a money collect icon for payment history
			label: "Payment History",
			path: "/admin/payments",
		},
		{
			key: "chats",
			icon: <MessageOutlined />,
			label: "Chats",
			path: "/admin/chats",
		},
	];

	// close on click outside
	useEffect(() => {
		const clickHandler = ({ target }) => {
			if (!sidebar.current || !trigger.current) return;
			if (
				!sidebarOpen ||
				sidebar.current.contains(target) ||
				trigger.current.contains(target)
			)
				return;
			setSidebarOpen(false);
		};
		document.addEventListener("click", clickHandler);
		return () => document.removeEventListener("click", clickHandler);
	});

	// close if the esc key is pressed
	useEffect(() => {
		const keyHandler = ({ keyCode }) => {
			if (!sidebarOpen || keyCode !== 27) return;
			setSidebarOpen(false);
		};
		document.addEventListener("keydown", keyHandler);
		return () => document.removeEventListener("keydown", keyHandler);
	});

	const closeSidebar = () => {
		setSidebarOpen(false);
	};

	return (
		<aside
			ref={sidebar}
			className={`absolute left-0 top-0 z-9999 flex h-screen w-72.5 flex-col overflow-y-hidden bg-backgroundDark duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${
				sidebarOpen ? "translate-x-0" : "-translate-x-full"
			}`}
		>
			{/* <!-- SIDEBAR HEADER --> */}

			<div className="flex items-center justify-between h-16 px-6 pb-8 lg:py-6.5">
				<div className="mt-4">
					<NavLink
						to="/admin"
						className="flex flex-col items-center p-3"
					>
						<img
							src={`./images/ElearningIo.png`}
							alt="Logo"
							className="h-30 w-auto"
						/>
						<p className="text-xl font-bold text-blue-500 text-center -mt-4">
							ELearning-Io
						</p>
					</NavLink>
				</div>

				<button
					ref={trigger}
					onClick={() => setSidebarOpen(!sidebarOpen)}
					aria-controls="sidebar"
					aria-expanded={sidebarOpen}
					className="block lg:hidden text-white"
				>
					<svg
						className="fill-current"
						width="20"
						height="18"
						viewBox="0 0 20 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
							fill=""
						/>
					</svg>
				</button>
			</div>
			{/* <!-- SIDEBAR HEADER --> */}

			<div className="flex flex-col flex-grow overflow-y-auto">
				{/* <!-- Sidebar Menu --> */}
				<nav className="mt-5 py-4 px-4 lg:mt-9 lg:px-6">
					{/* <!-- Menu Group --> */}
					<div>
						<h3 className="mb-4 ml-4 text-lg font-bold text-mainColor pt-4">
							MENU
						</h3>
						<ul className="mb-6 flex flex-col gap-1.5">
							{menuItems.map((item) => (
								<li key={item.key}>
									<NavLink
										to={item.path}
										className={`flex items-center p-2 gap-3.5 text-lg font-medium duration-300 ease-in-out hover:text-white ${
											pathname === item.path
												? "text-white"
												: "text-bodydark2"
										}`}
										onClick={closeSidebar}
									>
										<span className="w-6 h-6 flex items-center justify-center">
											{item.icon}
										</span>
										{item.label}
									</NavLink>
								</li>
							))}
						</ul>
					</div>
				</nav>
				{/* <!-- Sidebar Menu --> */}
			</div>

			{/* Logout Item */}
			<div className="mt-auto px-6 py-4">
				<button
					onClick={() => logout()}
					className="flex items-center gap-3.5 text-sm font-medium text-bodydark2 duration-300 ease-in-out hover:text-white"
				>
					<span className="w-6 h-6 flex items-center justify-center">
						<LogoutOutlined style={{ fontSize: "24px" }} />
					</span>
					<span className="text-lg">Log Out</span>
				</button>
			</div>
		</aside>
	);
};

export default Sidebar;
